@if (tiles().length) {
  <div
    class="border-t border-steel-10 bg-white py-4 shadow-dock md:py-2 xl:py-0 xl:pb-1 hidden md:block"
    [animate.enter]="trayEnterAnimation()"
    animate.leave="rma-animate-tray-out"
  >
    <div class="mx-auto max-w-location px-4 md:px-2 xl:px-0">
      <!-- Below md the actions sit above the row; from md they sit beside it, stacked. -->
      <div class="mb-3 flex items-center justify-between gap-3 md:hidden">
        <span class="font-bold text-steel-100">{{ heading() }}</span>

        <div class="flex items-center gap-3">
          <button rmaButton="outline" tone="brand" type="button" (click)="clear.emit()">{{ clearLabel() }}</button>
          <button rmaButton="solid" tone="brand" type="button" (click)="compare.emit()">{{ compareLabel() }}</button>
        </div>
      </div>

      <div class="flex items-center gap-6">
        <div class="relative min-w-0 grow">
          <div #scroller="rmaOverflowScroll" rmaOverflowScroll class="flex snap-x gap-3 overflow-x-auto pt-2 md:gap-5">
            @for (tile of tiles(); track tile.agentCode) {
              <div
                class="relative w-(--rma-compare-tile-width) shrink-0 snap-start [--rma-compare-tile-width:5.75rem] md:[--rma-compare-tile-width:6.25rem]"
                [animate.enter]="tileEnterAnimation()"
                animate.leave="rma-animate-tile-out"
              >
                <div class="relative h-(--rma-compare-tile-width) w-full overflow-hidden rounded-lg border border-steel-10">
                  <rma-profile-avatar
                    class="h-full w-full rounded-lg!"
                    [avatar]="tile.avatarImage"
                    [name]="tile.agentName"
                    [lazyLoad]="true"
                    size="standard"
                  />

                  @if (tile.logoUrl) {
                    <div
                      class="absolute inset-x-0 bottom-0 flex h-6 items-center justify-center px-1"
                      [style.background-color]="tile.primaryColour"
                    >
                      <div class="relative h-4 w-full">
                        <img
                          class="object-contain"
                          [ngSrc]="tile.logoUrl"
                          fill
                          disableOptimizedSrcset
                          [loaderParams]="{ transformations: 'ProfileBannerLogo' }"
                          alt=""
                        />
                      </div>
                    </div>
                  }
                </div>

                <button
                  type="button"
                  class="absolute -top-1.5 right-0 flex h-5 w-5 items-center justify-center rounded-full bg-steel-100/70 text-white"
                  [attr.aria-label]="removeLabel() + ' ' + tile.agentName"
                  (click)="remove.emit(tile.agentCode)"
                >
                  <rma-icon glyph="close" size="extraSmall" />
                </button>
              </div>
            }
          </div>

          <rma-scroll-chevron [canScroll]="scroller.canScroll()" [label]="scrollLabel()" (scrolled)="scroller.scrollRight()" />
        </div>

        <div class="hidden shrink-0 flex-col gap-3 md:flex">
          <button rmaButton="solid" tone="brand" type="button" class="w-50" (click)="compare.emit()">{{ compareLabel() }}</button>
          <button rmaButton="outline" tone="brand" type="button" class="w-50" (click)="clear.emit()">{{ clearLabel() }}</button>
        </div>
      </div>
    </div>
  </div>
}
